/**
 * @generated SignedSource<<d9432ed0e7233d67cb1bf30cdcaee4d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespQuickFilterDropdown_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuFilterArtSubject_viewer" | "SbSharedRefineMenuFilterCreator_viewer" | "SbSharedRefineMenuFilterItemLocation_viewer" | "SbSharedRefineMenuFilterMaterial_viewer" | "SbSharedRefineMenuFilterMetal_viewer" | "SbSharedRefineMenuFilterStone_viewer">;
  readonly " $fragmentType": "SbRespQuickFilterDropdown_viewer";
};
export type SbRespQuickFilterDropdown_viewer$key = {
  readonly " $data"?: SbRespQuickFilterDropdown_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespQuickFilterDropdown_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespQuickFilterDropdown_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMetal_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterStone_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterCreator_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterMaterial_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterItemLocation_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterArtSubject_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "6a8f70f64cd8944bc98e0b7f8daad2d3";

export default node;
